import { gql, useQuery } from '@apollo/client'

import {
  DmRoomsQuery,
  DmRoomsQueryVariables,
  UserDmRoomsConnectionFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  // userDmRoomsクエリを実行しDMルーム一覧を取得
  const { data, loading, fetchMore } = useQuery<
    DmRoomsQuery,
    DmRoomsQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {},
  })

  return {
    state: {
      userId: user?.uid ?? '',
      dmRooms: data?.userDmRooms ?? null,
      loading,
      hasNextPage: !!data?.userDmRooms?.pageInfo.hasNextPage,
    },
    actions: {
      /**
       * 次のページを取得する（無限スクロール）
       */
      async onFetchMore() {
        await fetchMore({
          variables: {
            // 最後のカーソル位置から続き取得
            pageInput: { cursor: data?.userDmRooms?.pageInfo.endCursor },
          },
        })
      },
    },
  }
})

/**
 * ユーザ用DMルーム一覧を取得するクエリ
 */
const QUERY = gql`
  query DmRooms($pageInput: PageInput) {
    userDmRooms(pageInput: $pageInput) {
      ...UserDmRoomsConnection
    }
  }
  ${UserDmRoomsConnectionFragmentDoc}
`
